import Vue from "vue";
import { Store } from "vuex";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import FollowerStatisticApi from "@/store/follower-statistics/-api";

@Module({
  name: "follower-statistics",
  stateFactory: true,
  namespaced: true,
})
export default class FollowerStatisticsStore extends VuexModule {
  followerStatistics: FollowerMap = {};

  @Action({ rawError: true })
  async fetchFollowerStatistics(profileId: string) {
    if (this.followerStatistics[profileId] !== undefined) {
      return;
    }

    try {
      const api = new FollowerStatisticApi(this.store.$axios);
      const response = await api.getFollowerStatistics(profileId);
      this.setFollowers(response.data);
    } catch (e) {}
  }

  @Mutation
  setFollowers(response: FollowersStatisticsResponse) {
    Vue.set(
      this.followerStatistics,
      response.followersStatistics.profileId,
      response.followersStatistics.followersCount,
    );
  }
}

export const getFollowerStatisticsStore = (store: Store<unknown>) => {
  return getModule(FollowerStatisticsStore, store);
};
